export default __webpack_public_path__ + "media/images/chevron-down-c4e04acdef59dff61b23b3b4ab71dc40.svg";